import { SubSection } from "context/BlogContext";
import React from "react";

interface PreviewQuoteProps {
  subSection: SubSection;
}

const PreviewQuote: React.FC<PreviewQuoteProps> = ({ subSection }) => {
  return (
    <div>
      {subSection.type === "quote" && (
        <div className="pt-5">
          <div className="p-5 border ">
            {subSection.title && (
              <h6 className="mb-2 text-15">{subSection.title}</h6>
            )}
            <p className="font-semibold text-[18px]">
              "{subSection.attrs?.text}"
            </p>
            {subSection.attrs?.author && (
              <p className="pt-1 font-medium text-[#838383] text-[15px]">
                - {subSection.attrs?.author}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewQuote;
